import SeoHead from './SeoHead';
import { Breadcrumbs } from './ComponentLibrary';
import { pageMeta } from '../seoUtils';

const CAREERS_EMAIL = 'hello@naijanestproperties.com';

const openRoles = [
  {
    title: 'Property Consultant Success Executive',
    location: 'Remote (Nigeria)',
    summary:
      "We're looking for a motivated and relationship-driven individual to help grow NaijaNest by building partnerships with estate agents and property consultants across Nigeria.",
    responsibilities: [
      'Reach out to estate/property consultants.',
      'Introduce NaijaNest and onboard new partners.',
      'Support consultants in creating profiles and publishing listings.',
      'Build lasting relationships and provide ongoing support.',
      'Gather feedback to help improve our platform.',
    ],
    requirements: [
      'Excellent communication skills.',
      'Confident speaking with people.',
      'Self-motivated and organised.',
      'Comfortable using WhatsApp, social media and online tools.',
      'Experience in real estate, sales, customer success or business development is an advantage.',
    ],
    perks: [
      'Be part of an exciting Nigerian proptech startup.',
      'Flexible remote working.',
      'Opportunity to grow with the company.',
      'Make a real impact from day one.',
    ],
  },
];

function mailtoFor(roleTitle) {
  return `mailto:${CAREERS_EMAIL}?subject=${encodeURIComponent(`Application: ${roleTitle}`)}`;
}

function CareersPage() {
  const seo = pageMeta({
    title: 'Careers',
    description:
      "Explore open roles at NaijaNest, Nigeria's property marketplace, and help us grow a more trustworthy way to search, list, and let property.",
    path: '/careers',
  });

  return (
    <div className="static-page careers-page">
      <SeoHead title={seo.fullTitle} description={seo.desc} url={seo.url} image={seo.img} />
      <Breadcrumbs
        items={[{ label: 'Home', href: '/' }, { label: 'Careers', current: true }]}
      />
      <section className="section">
        <header className="careers-page__intro">
          <h1>Careers at NaijaNest</h1>
          <p className="static-page__lead">
            We&apos;re building Nigeria&apos;s most trusted property marketplace, and we&apos;re
            looking for people who want to help grow it. Explore open roles below.
          </p>
        </header>

        {openRoles.map((role, index) => (
          <details key={role.title} className="careers-page__job" open={index === 0}>
            <summary className="careers-page__job-header">
              <div>
                <div className="careers-page__job-title-row">
                  <span className="careers-page__chevron" aria-hidden="true">
                    &#9656;
                  </span>
                  <h2 className="careers-page__job-title">{role.title}</h2>
                </div>
                <div className="careers-page__job-meta">{role.location}</div>
              </div>
              <span className="careers-page__badge">Hiring now</span>
            </summary>

            <div className="careers-page__job-body">
              <p>{role.summary}</p>

              <h3>What You&apos;ll Do</h3>
              <ul>
                {role.responsibilities.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>

              <h3>What We&apos;re Looking For</h3>
              <ul>
                {role.requirements.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>

              <h3>Why Join Us?</h3>
              <ul>
                {role.perks.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>

              <div className="careers-page__apply">
                <a className="careers-page__apply-btn" href={mailtoFor(role.title)}>
                  Apply via Email
                </a>
                <span className="careers-page__apply-hint">
                  Send your CV and a short intro to {CAREERS_EMAIL}
                </span>
              </div>
            </div>
          </details>
        ))}

        <p className="careers-page__section-label">Don&apos;t see a fit?</p>
        <div className="careers-page__empty-state">
          We&apos;re a small, growing team, so send us a speculative CV at{' '}
          <a href={`mailto:${CAREERS_EMAIL}`}>{CAREERS_EMAIL}</a> and tell us how you&apos;d like
          to contribute.
        </div>
      </section>
    </div>
  );
}

export default CareersPage;
